import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

const SessionLengthField = ({ dataPoint, index, handleFieldChange }) => {
  const preventNumberScroll = (event) => {
    event.preventDefault();
    event.target.blur();
  };

  return (
    <Box sx={{ gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextField
          type='number'
          size='small'
          value={dataPoint.sessionLength}
          onChange={(e) =>
            handleFieldChange(index, 'sessionLength', e.target.value)
          }
          placeholder='Enter length'
          sx={{
            width: '120px',
            '& .MuiOutlinedInput-root': {
              height: '32px',
              '& .MuiOutlinedInput-input': {
                padding: '6px 12px',
                fontSize: '14px',
              },
            },
          }}
          inputProps={{ min: 0, onWheel: preventNumberScroll }}
        />
        <Typography variant='body2' sx={{ color: 'var(--clr-mindly-black)' }}>
          minutes
        </Typography>
      </Box>
    </Box>
  );
};

export default SessionLengthField;
